/**
+-------------------------------------
 * dsbridge 交互类
+-------------------------------------
 * Copyright (c) 2019-10-09
 * Author HeroZheng
+-------------------------------------
*/

import dsbridge from 'dsbridge'

//1、获取Token
export function getToken(callback) {
    console.log("--app service get token");
    dsbridge.call("getToken", {}, v => {
        console.log("--app service get token-end:" + JSON.stringify(v));
        callback(v); //v.token
    });
}

//2、重新登录
export function needLogin(jsonParam,callback) {
    console.log("--app service need login");
    dsbridge.call("needLogin",jsonParam, v => {
    // jsonparam={
    //   pagetype:1,     //页面类型：0:页面内操作点赞、评论、关注  1：原生页  2：H5页
    //   url:"",         //H5路径，跳转H5
    //   type:'1',       //原生路径  1:写动态 2：图片  3：视频  4：提问  5：
    //   qid:364,        //问题id
    //   title：'',      //问题标题
    //   isReturn: true  //是否显示返回
    // }
        callback(v); //v.token
    });
}

//3、页面title
export function changeTitle(jsonParam) {
    // jsonParam={
    //   title:title 页面名称
    // }
    dsbridge.call("changeTitle", jsonParam);
}

//4、地图导航
export function openNavi(jsonParam) {
    // jsonparam={
    //   lng:"", //经度
    //   lat:""   //纬度
    // }
    console.log("--appservice--openNavi-开始" + JSON.stringify(jsonParam));
    dsbridge.call("openNavi", jsonParam);
    console.log("--appservice--openNavi-结束");
}

//5、获取当前位置
export function getPosition(callback) {
    try{
        dsbridge.call("getPosition", {}, v => {
            // v={
            //     lat:"",
            //     lng:""
            // }
            callback(v);
        });
    }catch(e){
        console.log(e.name + ": " + e.message);
    }
}

//6、调用手机通讯录
export function openContact(callback) {
    dsbridge.call("openContact", {}, v => {
        // v={
        //     name:"",
        //     phone:""
        // }
        callback(v);
    });
}

//7、调用手机打电话
export function callPhone(jsonParam) {
    // jsonParam={
    //     "phone":'13466687192'
    // }
    dsbridge.call("callPhone", jsonParam)
}

//8、分享
export function shareContent(jsonParam) {
    // jsonParam={
    //     type:'1',  // 1:分享到微信好友 2：分享到朋友圈
    //     weburl:'网页链接',
    //     wechatid:'小程序原始id'
    //     url:'小程序页面路径：/pages/article/article?scene=1029-21090',
    //     imageUrl:'小程序的预览图',
    //     title:'分享标题',
    //     content:'分享内容',
    //     user_id:'分享用户id',
    // }
    dsbridge.call("shareContent", jsonParam);
}

//9、轻提示
export function toast(jsonParam) {
    // jsonParam={
    //     message:'' //提示信息str
    // }
    console.log("--appservice toast start")
    dsbridge.call("toast", jsonParam);
    console.log("--appservice toast end")
}

//10、跳转到app页面
export function gotoApp(jsonParam) {
    // jsonParam={
    //     path:'' ,//原生路径 home bbs my
    //     openNewPage:false,  // true:重新打开新页面  false：不开新页面
    //     refresh:true   // true :跳转到app页面 并局部刷新（只调用接口重新刷下变化的数据即可
    //                    // false：跳转到app页面 不需要局部刷新
    // } 
    console.log("--appservice gotoApp start")
    dsbridge.call("gotoApp", jsonParam);
    console.log("--appservice gotoApp end")
}

//11、确认框
export function messageBox(jsonParam,callback) {
    // jsonParam={
    //     showCancelButton: true, //是否显示取消按钮
    //     title: '标题',
    //     message: '内容',
    //     subText:'确认提交',
    //     cancelText:'重新填写'          
    // }
    console.log("--appservice messageBox start")
    dsbridge.call("messageBox", jsonParam,v=>{
        // v={
        //     action:false    //  true  按了确定按钮  false 按了取消按钮
        // }

        callback(v);
    });
    console.log("--appservice messageBox end")
}

//12 调用手机相册
export function openPhotoAlbum(jsonParam,callback) {
    console.log("--appservice openPhotoAlbum start")
    dsbridge.call("openPhotoAlbum", jsonParam, v => {
        // jsonParam={
        //     type:1  //类型：1普通上传；2头像上传
        // }
        // v={
        //     pic:"", //图片路径-入库用
        //     pic_url:"" //图片连接地址-展示用
        // }
        console.log("--appservice openPhotoAlbum-end:" + JSON.stringify(v));
        callback(v);
    });
    console.log("--appservice openPhotoAlbum end")
}

//13 订单支付
export function payment(jsonParam, callback) {
    // jsonParam = {
    //     payType:"1"  , //1：微信支付  2：支付宝支付
    //     payParam:{
    //         payId:'' ,//系统订单号 
    //         fee:'',  //支付金额 单位:元
    //         title:''  //商品简单描述 
    //     }
    // }
    console.log("--appservice payment start:" + JSON.stringify(jsonParam));
    dsbridge.call("payment", jsonParam, v => {
        console.log("--appservice payment-end:" + JSON.stringify(v));
        // v={
        //     result:"0", //0支付成功 1 支付取消   2 ....
        //     resultNote:""  //支付错误描述 result非0时显示 需要填写正确
        // }
        callback(v);
    });
}

//14、返回按钮显示
export function isShowReturn(jsonParam) {
    console.log("--appservice isShowReturn start")
    // jsonParam={
    //     "state":true
    // }
    dsbridge.call("isShowReturn", jsonParam)
}

//15、分享按钮显示
export function isShowShare(jsonParam) {
    console.log("--appservice isShowShare start")
    // jsonParam={
    //     "state":true
    // }
    dsbridge.call("isShowShare", jsonParam)
}

//16、搜索按钮显示
export function isShowSearch(jsonParam) {
    console.log("--appservice isShowSearch start")
    // jsonParam={
    //     "state":true
    // }
    dsbridge.call("isShowSearch", jsonParam)
}

//17、退出
export function needLogout(callback) {
    console.log("--app service need logout");
    dsbridge.call("needLogout", {}, v => {
        callback(v); //v.token
    });
}

//18、打开新的webview
export function openWebView(jsonParam) {
    // jsonParam={
    //     url:'' ,//页面地址
    //     isReturn: true //是否显示返回
    // } 
    console.log("--appservice openWebView start")
    dsbridge.call("openWebView", jsonParam);
    console.log("--appservice openWebView end")
}

//19、发表动态/图片/视频/提问
export function goPost(jsonParam) {
    // jsonParam={
    //     qid:364,      //问题id
    //     type:'1',  // 1:写动态 2：图片  3：视频  4：提问  5：
    //     title：''   //问题标题
    // }
    dsbridge.call("goPost", jsonParam);
}

//20、选择话题传递参数
export function choiseType(jsonParam) {
    // jsonParam={
    //     idlist:[1,2,3],  // 话题类型id
    //     namelist:['远景齐聚','雷克萨斯','雷克萨斯']  //话题类型名称
    //     type:1   //操作   1:插入   2:替换
    // }
    dsbridge.call("choiseType", jsonParam);
}

//21、发布成功接收参数
export function getParams() {
    console.log("--app service get params");
    dsbridge.register('getParams', {}, v => {
        console.log("--app service get params-end:" + JSON.stringify(v));
        callback(v); 
    });
}

//22、接收话题类型
export function getParamsReturn() {
    console.log("--app service get paramsreturn");
    dsbridge.register('getParamsReturn', {}, v => {
        console.log("--app service get paramsreturn-end:" + JSON.stringify(v));
        callback(v); 
    });
}

//23、是否隐藏底部TAB
export function isTabbar(jsonParam) {
    console.log("--appservice isTabbar start"+JSON.stringify(jsonParam))
    // jsonParam={
    //     "state":true
    // }
    dsbridge.call("isTabbar", jsonParam)
}

//24、选择提问传递参数
export function choiseAskType(jsonParam) {
    // jsonParam={
    //     channel_id:5,//频道id
    //     column_id:4, //栏目id
    //     idlist:[1,2,3],  // 提问类型id
    //     namelist:['远景齐聚','雷克萨斯','雷克萨斯']  //提问类型名称
    // }
    dsbridge.call("choiseAskType", jsonParam);
}

//25、接收系统状态栏高度
export function getWinHeight(callback) {
    console.log("--app service get getWinHeight");
    dsbridge.call('getWinHeight', {}, v => {
        console.log("--app service get getWinHeight-end:" + JSON.stringify(v));
        callback(v); 
    });
}

//25、跳转小程序
export function openWechat(jsonParam) {
    console.log("--app service get openWechat");
    // jsonParam={
    //     url:'' ,//小程序页面地址
    // } 
    dsbridge.call("openWechat", jsonParam);
}
//26、关闭APP
export function closeApp() {
    console.log("--app service get closeApp");
    
    dsbridge.call("closeApp");
}
export default {
    getToken, //获取token
    needLogin,    //重新登录
    changeTitle, //改变title
    openNavi, //地图导航
    getPosition, //获取当前位置
    openContact, //调用手机通讯录
    callPhone, //调用手机打电话
    shareContent, //分享
    toast, //轻提示
    gotoApp, //跳转到app页面
    messageBox, //确认框
    openPhotoAlbum, //调用手机相册
    payment, //订单支付
    isShowReturn, //返回按钮显示
    isShowShare, //分享按钮显示
    isShowSearch, //搜索按钮显示
    needLogout, //退出
    openWebView, //打开新的webview
    goPost, //发表动态/图片/视频/提问
    choiseType, //话题类型
    getParams, //接收参数
    getParamsReturn, //接收话题数组
    isTabbar, //是否显示tabbar
    choiseAskType, //问题标签
    getWinHeight,  //状态栏高度
    openWechat,    //跳转小程序
    closeApp,     //退出app
};